import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20gradient%20flowing%20lines%20and%20soft%20glowing%20particles%2C%20luxury%20corporate%20atmosphere%2C%20amber%20and%20cream%20tones%2C%20ethereal%20dreamy%20quality%2C%20minimalist%20elegant%20design%2C%20high%20end%20background&width=1800&height=600&seq=kaiyun-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 to-primary-800/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开启您的
          <span className="text-primary-300"> 开云 </span>
          之旅了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          立即加入开云平台，体验高效、安全、智能的数字化服务，与50万+用户一起探索无限可能。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/categories')}
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white text-primary-700 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费体验
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button
            onClick={() => navigate('/about')}
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/30 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            联系咨询
          </button>
        </div>
      </div>
    </section>
  );
}